import { Button, Col, Dropdown, DropdownButton, Modal, Row } from "react-bootstrap";
import { CTeDto } from "../CTe.Dto";

interface Props {
  show: boolean;
  cte: CTeDto | undefined;
  onReturn: () => void;
  onDelete: (value: CTeDto) => void;
  onDownloadXml: (value: CTeDto) => void;
  onFetchStatus: (value: CTeDto) => void;
  onSend: (value: CTeDto) => void;
  onEdit: (value: CTeDto) => void;
  onDuplicate: (value: CTeDto) => void;
  onPrint?: (value: CTeDto) => void;
  onDownloadDacte?: (value: CTeDto) => void;
  onShareDacte?: (value: CTeDto) => void;
  onEvent?: (value: CTeDto) => void;
  onVisualizar?: (value: CTeDto) => void;
}

const CTeModalPropriedadesView = (props: Props) => {
  const finalizada = props.cte?.autorizacao?.codigoStatusResposta === 100;

  const onVisualizarHandler = () => {
    if (props.cte) {
      if (props.onVisualizar) {
        props.onVisualizar(props.cte);
      } else if (props.cte.id) {
        window.open(`/fiscal/cte/${props.cte.id}/visualizar`, "_blank");
      }
    }
  };

  const onDeleteHandler = () => {
    if (props.cte) {
      props.onReturn();
      props.onDelete(props.cte);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.cte) {
      props.onDownloadXml(props.cte);
    }
  };

  const onDuplicateHandler = () => {
    if (props.cte) {
      props.onDuplicate(props.cte);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.cte) {
      props.onFetchStatus(props.cte);
    }
  };

  const onReturnHandler = () => {
    props.onReturn();
  };

  const onSendHandler = () => {
    if (props.cte) {
      props.onSend(props.cte);
    }
  };

  const onEditHandler = () => {
    if (props.cte) {
      props.onEdit(props.cte);
    }
  };

  const onPrintHandler = () => {
    if (props.cte && props.onPrint) {
      props.onPrint(props.cte);
    }
  };

  const onDownloadDacteHandler = () => {
    if (props.cte && props.onDownloadDacte) {
      props.onDownloadDacte(props.cte);
    }
  };

  const onShareDacteHandler = () => {
    if (props.cte && props.onShareDacte) {
      props.onShareDacte(props.cte);
    }
  };

  const onEventHandler = () => {
    if (props.cte && props.onEvent) {
      props.onEvent(props.cte);
    }
  };

  return (
    <Modal show={props.show} centered onHide={props.onReturn}>
      <Modal.Header closeButton>
        <Modal.Title>Propriedades do CT-e</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col xs={6}>
            <strong>Número CT-e:</strong> {props.cte?.numeroCte}
          </Col>
          <Col xs={6}>
            <strong>Série:</strong> {props.cte?.serie}
          </Col>
        </Row>
        {props.cte?.remetente?.nome && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Remetente:</strong> {props.cte.remetente.nome}
            </Col>
          </Row>
        )}
        {props.cte?.destinatario?.nome && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Destinatário:</strong> {props.cte.destinatario.nome}
            </Col>
          </Row>
        )}
        {props.cte?.autorizacao && (
          <>
            <Row className="mb-1">
              <Col xs={12}>
                <strong>Status Envio:</strong>{" "}
                {props.cte.autorizacao.codigoStatusEnvio} -{" "}
                {props.cte.autorizacao.descricaoStatusEnvio}
              </Col>
            </Row>
            <Row className="mb-1">
              <Col xs={12}>
                <strong>Status Resposta:</strong>{" "}
                {props.cte.autorizacao.codigoStatusResposta} -{" "}
                {props.cte.autorizacao.descricaoMotivoResposta}
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {finalizada ? (
          <>
            <DropdownButton
              variant="outline-primary"
              title="DACTE"
              id="dropdown-imprimir"
              className="messagebox-btn-cancel"
            >
              <Dropdown.Item onClick={onPrintHandler}>
                Imprimir agora
              </Dropdown.Item>
              <Dropdown.Item onClick={onShareDacteHandler}>
                Compartilhar
              </Dropdown.Item>
              <Dropdown.Item onClick={onDownloadDacteHandler}>Baixar</Dropdown.Item>
            </DropdownButton>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDownloadXmlHandler}
            >
              Baixar XML
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDuplicateHandler}
            >
              Duplicar
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onEventHandler}
            >
              Eventos
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outline-danger"
              className="messagebox-btn-cancel"
              onClick={onDeleteHandler}
            >
              Excluir
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onFetchStatusHandler}
            >
              Consultar Situação
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onSendHandler}
            >
              Enviar
            </Button>
            <Button
              variant="outline-info"
              className="messagebox-btn-cancel"
              onClick={onEditHandler}
            >
              Alterar
            </Button>
          </>
        )}
        {props.cte?.id ? (
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onVisualizarHandler}
          >
            Visualizar
          </Button>
        ) : null}
        <Button
          variant="outline-secondary"
          className="messagebox-btn-cancel"
          onClick={onReturnHandler}
        >
          Sair
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CTeModalPropriedadesView;
